// FETCH ALL AasanErrors
export const FETCH_ASANAERROR_POINTS_REQUEST = 'FETCH_ASANAERROR_POINTS_REQUEST';
export const FETCH_ASANAERROR_POINTS_SUCCESS = 'FETCH_ASANAERROR_POINTS_SUCCESS';
export const FETCH_ASANAERROR_POINTS_FAILURE = 'FETCH_ASANAERROR_POINTS_FAILURE';

// CREATE AasanErrors
export const CREATE_ASANAERROR_POINTS_REQUEST = 'CREATE_ASANAERROR_POINTS_REQUEST';
export const CREATE_ASANAERROR_POINTS_SUCCESS = 'CREATE_ASANAERROR_POINTS_SUCCESS';
export const CREATE_ASANAERROR_POINTS_FAILURE = 'CREATE_ASANAERROR_POINTS_FAILURE';

// UPDATE AasanErrors
export const UPDATE_ASANAERROR_POINTS_REQUEST = 'UPDATE_ASANAERROR_POINTS_REQUEST';
export const UPDATE_ASANAERROR_POINTS_SUCCESS = 'UPDATE_ASANAERROR_POINTS_SUCCESS';
export const UPDATE_ASANAERROR_POINTS_FAILURE = 'UPDATE_ASANAERROR_POINTS_FAILURE';

// FETCH SINGLE STATE OF AasanErrors
export const FETCH_SINGLE_ASANAERROR_POINTS_REQUEST = 'FETCH_SINGLE_ASANAERROR_POINTS_REQUEST';
export const FETCH_SINGLE_ASANAERROR_POINTS_SUCCESS = 'FETCH_SINGLE_ASANAERROR_POINTS_SUCCESS';
export const FETCH_SINGLE_ASANAERROR_POINTS_FAILURE = 'FETCH_SINGLE_ASANAERROR_POINTS_FAILURE';

// DELETE AasanErrors
export const DELETE_ASANAERROR_POINTS_REQUEST = 'DELETE_ASANAERROR_POINTS_REQUEST';
export const DELETE_ASANAERROR_POINTS_SUCCESS = 'DELETE_ASANAERROR_POINTS_SUCCESS';
export const DELETE_ASANAERROR_POINTS_FAILURE = 'DELETE_ASANAERROR_POINTS_FAILURE';

export const RESET_ASANAERROR_POINTS_INFO = 'RESET_ASANAERROR_POINTS_INFO';

export const CREATE_ASANAERROR_POINTS_FORM = 'CREATE_ASANAERROR_POINTS_FORM';

export const UPDATE_ASANAERROR_POINTS_FORM = 'UPDATE_ASANAERROR_POINTS_FORM';

// NAVIGATE TO AasanErrors DETAILS COMPONENT
export const NAVIGATE_ASANAERROR_POINTS_DETAILS = 'NAVIGATE_ASANAERROR_POINTS_DETAILS';

// NAVIGATE TO AasanErrors COMPONENT
export const NAVIGATE_ASANAERROR_POINTS = 'NAVIGATE_ASANAERROR_POINTS';
